import React from 'react';
import { Image } from 'react-native';
import type { ArticleFeedProps, ArticleProps, BEEventProps } from "../types"
import { Button, Text, View } from '../Components/Themed';

type ArticleCardProps = {
    article_feed?:ArticleFeedProps,
    article:ArticleProps,
    width:number,
    onEvent?:(be_event:BEEventProps) => void,
    onSelectArticle:(article:ArticleProps) => void
}
const ArticleCard = ({ article_feed, article, width, onSelectArticle, onEvent }:ArticleCardProps) => {
    return (
        <Button style={{ flex:1, width:width, padding:0, borderRadius:8 }} onPress={() => {
                onSelectArticle(article)
                if(onEvent){
                    onEvent({
                        event_name: 'article_click',
                        event_data: {
                            article_id: article.article_id,
                            company_id: article.company_id,
                        },
                        level:2
                    })
                }
            }}>
            {article_feed ?
            <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10, borderTopRightRadius:8, borderTopLeftRadius:8 }}>
                <View transparent style={{ flex:1 }}>
                    <Text theme='h1'>{article_feed.feed_name}</Text>
                </View>
            </View>
            :<></>}
            <View type='body' style={{ flex:1, padding:0, borderBottomRightRadius:8, borderBottomLeftRadius:8 }}>
                <Image
                    source={{ uri: article.image?.url }}
                    style={{ width:width, height:width * 0.5}}
                    resizeMode='cover'
                />
                <View transparent style={{ padding:5, flex:1 }}>
                    <Text theme='h2'>{article.title}</Text>
                </View>
            </View>
        </Button>
    )
}

export default ArticleCard